import type { UnitDefinition } from './types';

export const UNIT_DEFS: Record<string, UnitDefinition> = {
  den: {
    id: 'den',
    name: 'Forest Den',
    emoji: '⌂',
    faction: 'land',
    role: 'base',
    moveLayer: 'ground',
    cost: 0,
    maxHp: 900,
    speed: 0,
    attackDamage: 0,
    attackRange: 0,
    attackCooldown: 1,
    sight: 280,
    buildTime: 0,
    supply: 0,
    description: '陸上勢力の拠点。動物部隊を呼び集める。'
  },
  fieldDen: {
    id: 'fieldDen',
    name: 'Field Den',
    emoji: '△',
    faction: 'land',
    role: 'base',
    moveLayer: 'ground',
    cost: 180,
    maxHp: 520,
    speed: 0,
    attackDamage: 0,
    attackRange: 0,
    attackCooldown: 1,
    sight: 230,
    buildTime: 0,
    constructionTime: 12,
    supply: 0,
    description: '前線用の小拠点。資源納品地点と生産地点になる。'
  },
  reefNest: {
    id: 'reefNest',
    name: 'Reef Nest',
    emoji: '◉',
    faction: 'ocean',
    role: 'base',
    moveLayer: 'surface',
    cost: 0,
    maxHp: 680,
    speed: 0,
    attackDamage: 0,
    attackRange: 0,
    attackCooldown: 1,
    sight: 280,
    buildTime: 0,
    supply: 0,
    description: '海洋勢力の拠点。海の群れを生産する。'
  },
  ant: {
    id: 'ant',
    name: 'Ant Swarm',
    emoji: 'A',
    faction: 'land',
    role: 'worker',
    moveLayer: 'ground',
    cost: 40,
    maxHp: 35,
    speed: 86,
    attackDamage: 4,
    attackRange: 28,
    attackCooldown: 0.55,
    sight: 150,
    buildTime: 4,
    gatherRate: 22,
    supply: 1,
    description: '安価な採集兼量産ユニット。集団で強い。'
  },
  wolf: {
    id: 'wolf',
    name: 'Wolf Pack',
    emoji: 'W',
    faction: 'land',
    role: 'soldier',
    moveLayer: 'ground',
    cost: 90,
    maxHp: 95,
    speed: 118,
    attackDamage: 14,
    attackRange: 34,
    attackCooldown: 0.85,
    sight: 190,
    buildTime: 7,
    supply: 2,
    description: '高速近接。複数で同じ目標を狙うとDPSが伸びる。'
  },
  eagle: {
    id: 'eagle',
    name: 'Eagle Scout',
    emoji: 'E',
    faction: 'land',
    role: 'scout',
    moveLayer: 'air',
    cost: 130,
    maxHp: 70,
    speed: 165,
    attackDamage: 9,
    attackRange: 72,
    attackCooldown: 1.0,
    sight: 360,
    buildTime: 9,
    supply: 2,
    description: '空中偵察。広い視界でFog of Warを剥がす。'
  },
  elephant: {
    id: 'elephant',
    name: 'Elephant Guard',
    emoji: 'Z',
    faction: 'land',
    role: 'siege',
    moveLayer: 'ground',
    cost: 240,
    maxHp: 360,
    speed: 54,
    attackDamage: 36,
    attackRange: 42,
    attackCooldown: 1.55,
    sight: 180,
    buildTime: 14,
    supply: 5,
    description: '鈍足重装。前線を押し上げる盾。'
  },
  dolphin: {
    id: 'dolphin',
    name: 'Dolphin Pod',
    emoji: 'D',
    faction: 'ocean',
    role: 'worker',
    moveLayer: 'surface',
    cost: 70,
    maxHp: 85,
    speed: 132,
    attackDamage: 10,
    attackRange: 60,
    attackCooldown: 0.9,
    sight: 310,
    buildTime: 5,
    gatherRate: 18,
    supply: 2,
    description: 'ソナーで索敵する水上ユニット。ケルプを採集可能。'
  },
  crab: {
    id: 'crab',
    name: 'Crab Line',
    emoji: 'C',
    faction: 'ocean',
    role: 'soldier',
    moveLayer: 'amphibious',
    cost: 90,
    maxHp: 125,
    speed: 70,
    attackDamage: 16,
    attackRange: 32,
    attackCooldown: 1.05,
    sight: 160,
    buildTime: 7,
    supply: 2,
    description: '浅瀬から陸へ上がる装甲兵。拠点への襲撃役。'
  },
  squid: {
    id: 'squid',
    name: 'Deep Squid',
    emoji: 'S',
    faction: 'ocean',
    role: 'scout',
    moveLayer: 'deepsea',
    cost: 130,
    maxHp: 80,
    speed: 105,
    attackDamage: 18,
    attackRange: 82,
    attackCooldown: 1.25,
    sight: 260,
    buildTime: 9,
    supply: 2,
    description: '深海ルートを使う奇襲ユニット。'
  }
};

export const PLAYER_PRODUCTION = ['ant', 'wolf', 'eagle', 'elephant'] as const;
export const AI_PRODUCTION = ['dolphin', 'crab', 'squid'] as const;
